import { Box, Divider, Grid2, InputLabel } from "@mui/material";
import React from "react";
import { RateBuilderRowContainer } from "@sinch/components/application/RatelistBuilder/RateBuilderRowContent/RateBuilderRowContent";
import {
  ComponentContentItem,
  ConditionContentItem,
  RateContentItem,
  UnitContentItem,
} from "@sinch/components/application/RatelistBuilder/RateBuilderRowContent/RateBuilderRowOverview/styled";
import { useRateBuilderSettings } from "@sinch/components/application/RatelistBuilder/UtilitiesProviders/RateBuilderSettingsProvider";
import { useTranslation } from "react-i18next";

export const RateBuilderTreeHeader: React.FC = () => {
  const { t } = useTranslation();
  const { mode } = useRateBuilderSettings();

  if (mode !== "view" && mode !== "override") {
    return null;
  }

  return (
    <Box sx={{ position: "relative" }}>
      <Box
        sx={{
          width: "100%",
          minWidth: "320px",
          pl: 1,
          paddingRight: `calc(5 * var(--mui-spacing) + 18px + 1px)`,
          "&::before": {
            content: '" "',
            display: "block",
            position: "absolute",
            width: "1px",
            borderLeft: "var(--tree-lines-width, 2px) solid var(--lines-color)",
            height: "100%",
            left: "calc(var(--main-line-offset) * -1 - var(--tree-lines-width, 2px) / 2)",
            top: 0,
          },
        }}
      >
        <RateBuilderRowContainer container size={{ xs: 12, lg: "grow" }} spacing={1}>
          <ConditionContentItem
            className="RateBuilderRowContentItem-full"
            display="flex"
            justifyContent="flex-start"
            size="grow"
          >
            <InputLabel sx={{ pb: 0 }}>{t("RateBuilder.condition")}</InputLabel>
            <Divider
              orientation="vertical"
              sx={(theme) => ({
                height: "1rem",
                [theme.breakpoints.down("lg")]: {
                  display: "none",
                },
              })}
            />
          </ConditionContentItem>
          <Grid2
            container
            size={{ xs: 12, lg: "auto" }}
            spacing={1}
            sx={(theme) => ({
              minWidth: "40vw",
              [theme.breakpoints.down("md")]: {
                minWidth: "100%",
                width: "100%",
              },
            })}
          >
            <UnitContentItem display="flex" justifyContent="flex-start" size={{ xs: "grow", lg: 4 }}>
              <InputLabel sx={{ pb: 0 }}>{t("unit")}</InputLabel>
            </UnitContentItem>
            <RateContentItem display="flex" justifyContent="flex-end" size={{ xs: "grow", lg: 4 }}>
              <InputLabel sx={{ pb: 0 }}>{t("RateBuilder.rate")}</InputLabel>
              <Divider orientation="vertical" sx={{ height: "1rem" }} />
            </RateContentItem>
            <ComponentContentItem display="flex" justifyContent="flex-end" size={{ xs: "auto", lg: 4 }}>
              <InputLabel sx={{ pb: 0 }}>{t("Ratelist.component")}</InputLabel>
            </ComponentContentItem>
          </Grid2>
        </RateBuilderRowContainer>
      </Box>
    </Box>
  );
};
